import { isPayloadSource } from "src/utils/hubSource";

/**
 * Past events data source: `static` (per-year locale JSON) or `payload` (pg-payload-cms).
 * Controlled by `past-events` in `REACT_APP_PAYLOAD_SOURCES`.
 * @returns {'static' | 'payload'}
 */
export function getPastEventsSource() {
  return isPayloadSource("past-events") ? "payload" : "static";
}

export function isPayloadPastEventsSource() {
  return isPayloadSource("past-events");
}

/**
 * Normalizes an i18n language value to a supported past-events locale.
 * Shared by usePastEvents / usePastEvent so both hooks resolve the same way.
 * @param {string} locale
 * @returns {'en' | 'fr'}
 */
export function normalizePastEventsLocale(locale) {
  return locale === "fr" ? "fr" : "en";
}
